import { MonitorIOBindingResult } from './binding/binding.types';
import {
  MonitorRealtimeDataConfig,
  useMonitorRealtimeData,
} from './monitor-realtime-data.hooks';

interface MachineIOHookProps {
  id?: string;
  config?: MonitorRealtimeDataConfig;
}

const useMachineIO = (props: MachineIOHookProps): MonitorIOBindingResult[] => {
  const data = useMonitorRealtimeData(props.id, props.config);
  return data.io ?? [];
};

export { useMachineIO };
